//tw文件
module.exports = {
  index1: "註冊",
  index2: "登錄",
  index3: "更多信息",
  index3_1: "節點加速",
  ssl: "獲取SSL節點",
  ssl_copy: '獲取成功，請粘貼至應用程序使用',
  index4: "首頁",
  index5: "關於我們",
  index6: "關注我們",
  index7: "語言",
  index8: "選擇您的加密資產",
  index9: "是最值得信賴的加密貨幣交易所，以安全性而聞名。",
  index10: "會員已經加入。",
  index11: "立即開設您的免費帳戶",
  index12: "現在註冊!",
  index13: "交易市場",
  index14: "一次革命都需要一個領導者。",
  index15: "首屈一指的交易平台專為那些掌握區塊鏈承諾的力量並希望成為運動一部分的人而設計。憑藉閃電般的交易速度、可靠的數字錢包和行業領先的安全性，我們創建了一個交易所來引領這項革命性的技術。",
  index16: "我們的優勢",
  index17: "安全第一",
  index18: "選擇交易所時，信任很重要。這就是為什麼安全一直並將永遠是我們的首要考慮因素。我們的平台從頭開始構建，具有多層保護，部署最有效和可靠的技術以確保資金和交易安全。",
  index19: "超越簡單交易的轉型",
  index20: "我們相信區塊鏈有潛力提供跨行業和超越加密的突破性解決方案。我們正在與世界各地的團隊合作，推進新的、創造性的代幣，這些代幣可以改變各地商品、服務和運營的管理方式。",
  index21: "快速、強大的技術",
  index22: "我們的交易引擎是為規模和速度而定制的，以促進在大量需求下的實時訂單執行。我們通過廣泛的 API 支持第三方交易平台和算法交易。",
  index23: "頂級數字貨幣市場",
  index24: "通過我們廣泛的市場列表，把握趨勢並充滿信心地進行交易。",
  index25: "智能手機",
  index26: "下載數字資產交易應用程序！",
  index27: "直接在您的智能手機上獲得一流的加密貨幣交易所。下載本應用程序進行交易更容易、更快、更安全。",
  index28: "蘋果應用商店",
  index29: "谷歌應用商店",
  index30: "用戶感言",
  index31: "我們是什麼？",
  index32: "我們是一個在線數字資產交易平台。您可以在平台購買各种加密资产，如BTC、LTC、ETH、BCH、GDOGE、XRP、TRX、BNB、和其他加密资产。",
  index33: "比特幣是什麼?",
  index34: "簡單來說，比特幣是一種數字資產, 這類資產交易可以在不需要信用卡或央行的去中心化情況下進行. 它的設計是為了讓用戶能夠以非常簡單、高效的方式進行網絡匯款。比特幣由中本聰在2009年開發，這種資產就像黃金, 但只在數字世界中存在. 這個概念聽起來可能像數字黃金,儘管它實際上有很大的不同。",
  index35: "如何存款到您賬戶?",
  index36: '点击 "資產-充值" , 选择 "您要使用的付款方式".例如: BTC，ETH，USDT。输入您希望购买的金额。複製錢包地址進行轉賬，转账完成后, 不要忘记填写您的 "存款憑證"。请等待我们的财务团队确认您的存款. 您的资金将于10-30分鐘内显示在您的余额中。',
  index37: "聯繫我們",
  index38: "版權所有",
  index39: "注意",
  index40: "本網站的目的僅在於顯示有關",
  index41: "應用程序上可用的產品和服務的信息應用程序上可用產品和服務的信息。它無意提供對任何此類產品和服務的訪問。您可以在應用程序上訪問此類產品和服務。",
  index42: "對於所有媒體和採訪請求，請聯繫",
  index43: "尋找推廣你的",
  index44: "對合作機會感興趣",
  index45: "常見問題",
  index46: "給我們發電子郵件",

  about1: "我們是全球領先的數字貨幣資產交易平台，致力於為用戶提供安全、專業、便捷的數字貨幣交易服務。我們切實從用戶角度出發，憑藉對區塊鏈領域的深刻認知，為全球用戶甄選優質幣種，引領區塊鏈技術潮流。",
  about2: "核心團隊匯聚了資深技術工程師、全球區塊鏈研究專家、國際化運營團隊以及世界級風控專家等行業內頂尖人才，採用全球領先的加密技術，自主研發的集群式內存撮合系統，集合多幣種，支持多語言，致力於為全球用戶提供更安全、更穩定、更便捷的數字資產交易。",
  about3: "我們數字資產交易服務平台以數字資產交易服務為重點，提供專業的交易功能，智能交易和智能撮合，便捷交易，資金委託，賬戶輕鬆管理。同時與行業中大小型數字貨幣交易所進行聯繫合作，信息溝通交流，達成數字資產覆蓋全世界的共同理念。",
  about4: "便捷流暢的用戶體驗，我們用心雕琢用戶的使用習慣，本著體驗至上的原則進行了全流程設計系統提供7-24不間斷交易服務系統級的安全防護。深耕數字貨幣行業，積聚了大批數字貨幣行業的研發人才致力於為用戶提供頂級的系統級安全保障。持續的引進各國數字貨幣為用戶提供全球範圍內的交易服務，豐富的數字貨幣幣種收集貨幣市場中的優質幣種，提供種類全面的數字貨幣",
  about5: "我們時刻傾聽、關心和思進。我們希望可以融合加密貨幣和傳統金融業的優勢不斷地創新。通過卓越的平台能力和專業的設計理念為我們的用戶帶來行業內最安全、高效、公平和透明的交易體驗。",
}



// WEBPACK FOOTER //
// ./src/common/lang/tw.js